// import { useGuild } from 'app/frontend/base/config/context/guild'

const HeaderTiles = () => {
  // const { currentTeam } = useGuild()

  return <div></div>
}

export default HeaderTiles
